// Stage 8 — Showings.
// v1: mock activity feed showing tour requests + a placeholder availability hint.
// Future: real calendar integration (Google / Cal.com), AI follow-up to buyers
// for feedback summaries, AI batching of optimal showing windows.

const MOCK_REQUESTS = [
  { buyer: "Buyer #B41", time: "Sat 10:00 AM", agent: "self-toured" },
  { buyer: "Buyer #B17", time: "Sat 2:30 PM",  agent: "with buyer's agent" },
  { buyer: "Buyer #C03", time: "Sun 11:00 AM", agent: "self-toured" },
];

export default function ShowingsStage({ state, journey, update }) {
  return (
    <>
      <div className="s-ai-pill" style={{ marginBottom: 14 }}>★ AI · Coming soon: auto-batch optimal tour slots, follow up with each buyer, summarize feedback</div>

      <p style={{ color: "#5b7365", fontSize: 14, lineHeight: 1.7, margin: "0 0 14px" }}>
        Buyers request private tours through your listing. Coordinate self-tours or agent-accompanied visits directly.
      </p>

      <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: "#9aa9a0", letterSpacing: "0.08em", marginBottom: 8, textTransform: "uppercase" }}>
        Example activity — live requests appear here once your listing is public
      </div>
      {MOCK_REQUESTS.map((r) => (
        <div key={r.buyer + r.time} className="s-vendor passive" style={{ marginBottom: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 6 }}>
            <div className="s-vendor-name">{r.buyer}</div>
            <div className="s-vendor-meta">{r.time}</div>
          </div>
          <div className="s-vendor-meta green">{r.agent}</div>
        </div>
      ))}
    </>
  );
}
